import { Injectable } from "@angular/core";
import { RestService } from "../core/core/rest.service";
import { IssueRow, Issue, IssueElement, ChangeStateEntity, IssueRelation } from "./issues.model";
import { ObjectToSelect } from "../core/shared/objectToSelect.model";
import { Worklog } from "../worklogs/worklogs.model";

@Injectable()
export class IssuesRest {
    constructor(private http: RestService) { }

    public getIssues() {
        return this.http.get<IssueRow[]>('api/issues/grid');
    }

    public getIssue(issueId: number, getWorklogs?: boolean ) {
        if (getWorklogs) {
            return this.http.get<Issue>(`api/issues/issue/${issueId}/${getWorklogs}`);
        } else {
        return this.http.get<Issue>(`api/issues/issue/${issueId}/${false}`);
        }
    }

    public createEmptyIssue(employeeId: number) {
        return this.http.get<Issue>(`api/issues/createEmptyIssue/${employeeId}`);
    }

    public saveIssue(issue: Issue, isNew: boolean) {
        return this.http.post(`api/issues/saveIssue/${isNew}`, issue);
    }

    public removeIssue(id: number) {
        return this.http.post(`api/issues/deleteIssue/${id}`, {});
    }

    public getAssignedToSelect() {
        return this.http.get<ObjectToSelect[]>('api/issues/getAssignedToSelect');
    }

    public getIssueTypes() {
        return this.http.get<ObjectToSelect[]>('api/issues/getIssueTypes');
    }

    public getEmployees() {
        return this.http.get<ObjectToSelect[]>('api/issues/getEmployees');
    }

    public getCustomerIdsToSelect() {
        return this.http.get<ObjectToSelect[]>('api/issues/getCustomerIdsToSelect');
    }

    public getCustomerEmployees(customerId: number) {
        return this.http.get<ObjectToSelect[]>(`api/issues/getCustomerEmployees/${customerId}`);
    }

    public getDepartments() {
        return this.http.get<ObjectToSelect[]>('api/issues/getDepartments');
    }

    public getSystemVersions(customerId: number) {
        return this.http.get<ObjectToSelect[]>(`api/issues/getSystemVersions/${customerId}`);
    }

    public getStates() {
        return this.http.get<ObjectToSelect[]>('api/issues/getStates');
    }

    public getFunctionalities() {
        return this.http.get<ObjectToSelect[]>('api/issues/getFunctionalities');
    }

    public saveElement(element: IssueElement, isNew: boolean) {
        return this.http.post(`api/issues/saveElement/${isNew}`, element);
    }

    public removeElement(element: IssueElement) {
        return this.http.post(`api/issues/removeElement/${element.id}/${element.issueId}`, {});
    }

    public removeWatcher(id: number) {
        return this.http.post(`api/issues/removeWatcher/${id}`, {});
    }

    public removeRelation(id: number) {
        return this.http.post(`api/issues/removeRelation/${id}`, {});
    }

    public changeStates(selected: ChangeStateEntity) {
        return this.http.post<boolean>(`api/issues/changeStates`, selected);
    }

    public getIssueRowsByFilter(data: {id: number, value: string}) {
        return this.http.post<IssueRow[]>(`api/issues/rows`, data );
    }

    public getIssueElements(issueId: number) {
        return this.http.get<IssueElement[]>(`api/issues/issue/elements/${issueId}`);
    }

    public getIssueRelations(issueId: number) {
        return this.http.get<IssueRelation[]>(`api/issues/issue/relations/${issueId}`);
    }

    public getIssueWorklogs(issueId: number) {
        return this.http.get<Worklog[]>(`api/issues/issue/worklogs/${issueId}`);
    }

    public saveIssueRelation(issueRelation: IssueRelation) {
        return this.http.post(`api/issues/relations/add`, issueRelation);
    }

    public copyIssue(issueId: number) {
        return this.http.post<Issue>(`api/issues/copyIssue`, issueId);
    }

    public checkIfIssueHasElements(id: number) {
        return this.http.get<boolean>(`api/issues/checkIfIssueHasElements/${id}`);
    }

    public getEmptySystemVersion() {
        return this.http.get<number>(`api/issues/getEmptySystemVersion`);
    }

}
